import React from "react";
import { Card } from "../components/ui/card";

export default function StatsCard({ label, value, icon: Icon, accent = "blue", testId }) {
  const tints = {
    emerald: "text-emerald-600 bg-emerald-50 border-emerald-100",
    amber: "text-amber-600 bg-amber-50 border-amber-100",
    blue: "text-blue-600 bg-blue-50 border-blue-100",
    rose: "text-rose-600 bg-rose-50 border-rose-100",
    violet: "text-violet-600 bg-violet-50 border-violet-100",
  };
  return (
    <Card
      className="rounded-sm border-slate-200 bg-white p-5 shadow-none transition-colors hover:border-slate-300"
      data-testid={testId}
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">
            {label}
          </div>
          <div className="mt-2 text-3xl font-semibold tracking-tight text-slate-900 tabular-nums">
            {value}
          </div>
        </div>
        {Icon && (
          <div className={`rounded-sm border p-2 ${tints[accent] || tints.blue}`}>
            <Icon className="h-4 w-4" strokeWidth={2} />
          </div>
        )}
      </div>
    </Card>
  );
}
